// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBWPwTuGXzwchNUtg5PFuurZwpwg910h60",
    authDomain: "school-charts.firebaseapp.com",
    databaseURL: "https://school-charts.firebaseio.com",
    projectId: "school-charts",
    storageBucket: "school-charts.appspot.com",
    messagingSenderId: "401304359698",
    appId: "1:401304359698:web:d29a1884a52bcfced999cb",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
